export default __webpack_public_path__ + "assets/a67309a0b71f809f99941a912eabe1b2.svg";